import { Injectable, Inject } from '@angular/core';
import { Instructor } from '../model/instructor.model';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { DateSlot } from '../model/dateslot.model';
import { LessonType } from '../model/lesson-type.model';
import { SportType } from '../model/sport-type.model';
import { InstructorStatus } from '../model/instructor-status.model';
import { Lesson } from '../model/lesson.model';

@Injectable({
  providedIn: 'root'
})
export class InstructorService {

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') private baseUrl: string) {

  }


  getAll(): Observable <Instructor[]> {
    return this.httpClient.get<Instructor[]>(this.baseUrl + '/api/Instructors/GetAllInstructors');
  }

  getById(id: number): Observable <Instructor> {
    return this.httpClient.get<Instructor>(`${this.baseUrl}/api/Instructors/GeInstructorById/${id}`);
  }

  delete(id: number): Observable<boolean> {
    return this.httpClient.post<boolean>(`${this.baseUrl}/api/Instructors/DeleteInstructor/${id}`, '');
  }

  edit(instructor: Instructor): Observable<boolean> {
    return this.httpClient.post<boolean>(`${this.baseUrl}/api/Instructors/EditInstructor`, instructor);
  }

  add(instructor: Instructor): Observable<boolean> {
    return this.httpClient.post<boolean>(`${this.baseUrl}/api/Instructors/AddInstructor`, instructor);
  }

  deleteDateAvailable(instructorId: number, id: number): Observable<boolean> {
    return this.httpClient.post<boolean>(`${this.baseUrl}/api/Instructors/DeleteDateAvailable/${instructorId}/${id}`, '');
  }

  addDateAvailable(instructorId: number, dateSlot: DateSlot): Observable<DateSlot> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const body = JSON.stringify(dateSlot);
    return this.httpClient.post<DateSlot>(`${this.baseUrl}/api/Instructors/AddDateAvailable/${instructorId}`, body, httpOptions);
  }

  updateDateAvailable(instructorId: number, dateSlot: DateSlot): Observable<DateSlot> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const body = JSON.stringify(dateSlot);
    return this.httpClient.post<DateSlot>(`${this.baseUrl}/api/Instructors/EditDateAvailable/${instructorId}`, body, httpOptions);
  }

  addLessonType(instructorId: number, lessonTypeId: number) {
    return this.httpClient.post<LessonType[]>(`${this.baseUrl}/api/Instructors/AddLessonType/${instructorId}/${lessonTypeId}`, '');
  }

  deleteLessonType(instructorId: number, lessonTypeId: number) {
    return this.httpClient.post<LessonType[]>(`${this.baseUrl}/api/Instructors/DeleteLessonType/${instructorId}/${lessonTypeId}`, '');
  }

  addSportType(instructorId: number, sportTypeId: number) {
    return this.httpClient.post<SportType[]>(`${this.baseUrl}/api/Instructors/AddSportType/${instructorId}/${sportTypeId}`, '');
  }

  deleteSportType(instructorId: number, sportTypeId: number) {
    return this.httpClient.post<SportType[]>(`${this.baseUrl}/api/Instructors/DeleteSportType/${instructorId}/${sportTypeId}`, '');
  }

  getInstructorLessons(instructorId: number): Observable<Lesson[]> {
    return this.httpClient.get<Lesson[]>(`${this.baseUrl}/api/Instructors/GetInstructorLessons/${instructorId}`);
  }



  //ToDo: Prebaciti u odvojeni servis
  /* lessonTypes(): LessonType[] {
    return [
      new LessonType(0, 'Individual', 'Individual'),
      new LessonType(1, 'Group2', 'Group2'),
      new LessonType(2, 'Group4', 'Group4'),
      new LessonType(3, 'Demo', 'Demo')
    ];
  }

  sportTypes(): SportType[] {
    return [
      new SportType(0, 'Ski', 'Ski'),
      new SportType(1, 'Snowboard', 'Snowboard')
    ];
  }

  instructorStatus(): InstructorStatus[] {
    return [
      new InstructorStatus(0, 'Aveiable', 'Aveiable'),
      new InstructorStatus(1, 'Injured', 'Injured')
    ];
  } */


    
  

}
